import React, { useState, useEffect } from "react";
import "./SpotRegistration.css";
import { FaRupeeSign } from "react-icons/fa";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BASE_URL from "../Config";

const SpotRegistration = () => {
  const [paymentdetails, setPayment] = useState([]);
  const [eventData, setEventData] = useState([]);
  const navigate = useNavigate();
  console.log("paymentdetails>>>>>", eventData);
  const initialValues = {
    deletegate_category: "",
    dName: "",
    ddesignation: "",
    demail: "",
    ddial_code: "91",
    dmobile: "",
    organization_name: "",
    GSTIN: "",
    amount: "",
    tax: "",
    totalAmount: "",
    event_id: "",
  };

  const validationSchema = Yup.object().shape({
    dName: Yup.string().required("Name is required"),
    dmobile: Yup.string()
      .matches(/^[0-9]{10,15}$/, "Invalid mobile number")
      .required("Mobile number is required"),
    demail: Yup.string().email("Invalid email").required("Email is required"),
    organization_name: Yup.string(),
    GSTIN: Yup.string()
      .nullable()
      .when("organization_name", {
        is: (orgName) => orgName && orgName.trim() !== "",
        then: (schema) =>
          schema
            .notRequired("GSTIN is required")
            .matches(
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/,
              "Invalid GSTIN format"
            ),
      }),
  });
  const getPaymentEventData = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/getMasterEvent`);

      console.log("Success:", response.data?.data);
      setEventData(response.data?.data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  useEffect(() => {
    getPaymentEventData();
  }, []);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const userRole = parseInt(sessionStorage.getItem("userRole"), 10);

      const payload = {
        name: values.dName,
        event_id: eventData[0]?.id,
        mobile: values.dmobile,
        dial_code: values.ddial_code,
        email: values.demail,
        designation: values.ddesignation,
        organization_name: values.organization_name,
        GSTIN: values.GSTIN,
        deletegate_category: values.deletegate_category || "Delegate",
        amount: paymentdetails[0]?.amount,
        tax: paymentdetails[0]?.tax,
        total_amount: paymentdetails[0]?.total_amount,
        payment_status: "Pending",
      };

      const response = await axios.post(
        `${BASE_URL}/InstantSpotRegistration`,
        payload
      );

      resetForm();

      if (userRole === 5 || userRole === 7 || userRole === 8) {
        navigate(-1); // Internal route
      } else {
        await Swal.fire({
          icon: "success",
          title: "Registered Successfully",
          text: "",
          confirmButtonText: "OK",
          confirmButtonColor: "#F8C400",
        });

        navigate("/thankyou"); // External in new tab
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Registration Failed",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const getPayment = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/getSpotPaymentFee`);

      setPayment(response.data?.data);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Registration failed!");
    }
  };

  useEffect(() => {
    getPayment();
  }, []);

  return (
    <div className="card">
      <div className="card-body">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <fieldset id="step1">
                <div className="form-card clearfix">
                  {/* Fee Summary */}
                  <div className="package-item">
                    <h3 className="package-title">Delegate Fee</h3>
                    <div className="delegate-fees row">
                      <div className="col-md-12 col-sm-12">
                        <div className="delegate-item">
                          <p>
                            <span>Fee</span>
                            <strong className="d-flex align-items-center gap-2">
                              <FaRupeeSign /> {paymentdetails[0]?.amount}
                            </strong>
                          </p>
                          <p>
                            <span>Tax</span>
                            <strong className="d-flex align-items-center gap-2">
                              <FaRupeeSign /> {paymentdetails[0]?.tax}
                            </strong>
                          </p>
                          <p>
                            <span>Total</span>
                            <strong className="d-flex align-items-center gap-2">
                              <FaRupeeSign /> {paymentdetails[0]?.total_amount}
                            </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Delegate Type */}
                  <h2 className="package-title company">Deletegate Type</h2>
                  <div className="row mb-3">
                    <div className="form-group mb-3 col-md-6">
                      <Field
                        as="select"
                        name="deletegate_category"
                        className="form-control"
                      >
                        <option value="Delegate">Delegate</option>
                      </Field>
                    </div>
                  </div>

                  {/* Delegate Info */}
                  <h2 className="package-title">Delegates Information</h2>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Name</label>
                      <Field
                        name="dName"
                        className="form-control"
                        placeholder="Enter a Name"
                      />
                      <ErrorMessage
                        name="dName"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Designation</label>
                      <Field
                        name="ddesignation"
                        className="form-control"
                        placeholder="Enter Designation"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Email</label>
                      <Field
                        name="demail"
                        type="email"
                        className="form-control"
                        placeholder="Enter Email"
                      />
                      <ErrorMessage
                        name="demail"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Mobile No.</label>
                      <div className="input-group">
                        <Field as="select" name="ddial_code" className="px-3">
                          <option value="91">91</option>
                        </Field>
                        <Field
                          name="dmobile"
                          className="form-control"
                          placeholder="Enter Mobile No."
                        />
                      </div>
                      <ErrorMessage
                        name="dmobile"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                  </div>

                  {/* Company Info */}
                  <h2 className="package-title company">Company Information</h2>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Organization Name</label>
                      <Field
                        name="organization_name"
                        className="form-control"
                        placeholder="Organization Name"
                      />
                      <ErrorMessage
                        name="organization_name"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>GSTIN</label>
                      <Field name="GSTIN">
                        {({ field, form }) => (
                          <input
                            {...field}
                            type="text"
                            className="form-control"
                            placeholder="GSTIN"
                            style={{ textTransform: "uppercase" }}
                            onChange={(e) => {
                              const value = e.target.value.toUpperCase();
                              form.setFieldValue("GSTIN", value);
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="GSTIN"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-md btn-primary tra-black-hover submit"
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      background: "#F8C400",
                      border: "0",
                      color: "#1B1B1D",
                      borderRadius: "50px",
                      padding: "8px 20px",
                      marginTop: "20px",
                      float: "right",
                      height: "37px",
                    }}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </fieldset>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SpotRegistration;
